import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import { blue, red } from "@mui/material/colors";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Divider } from "@mui/material";
import HouseIcon from "@mui/icons-material/House";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import logo from "../../images/logos/logo2.png";

const Footer = () => {
  return (
    <Grid container spacing={1} marginTop={5}>
      <Grid item xs={12} sm={6} md={12} marginBottom={2}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          width={{ xs: "100%", sm: "100%" }}
          flexDirection={{ xs: "column", sm: "row" }}
        >
          <Box
            display="flex"
            flexWrap={"wrap"}
            alignItems={"left"}
            flexDirection={"column"}
            width={{ xs: "90%", sm: "25%" }}
          >
            <Box
              display={"flex"}
              component="a"
              underline="none"
              href="/"
              title="OnDesign"
            >
              <img src={logo} alt="logo" width={"80%"} />
            </Box>
            <Typography
              underline="none"
              component="a"
              color="#bbb"
              variant={"subtitle2"}
              lineHeight={2}
              paddingTop={"10%"}
            >
              OnDesign is a digital agency that offers a wide scale of creative
              services, including brand development, web development and lots
              more.
            </Typography>
          </Box>
          <Box
            display="flex"
            flexWrap={"wrap"}
            justifyContent={"space-between"}
            width={{ xs: "95%", sm: "100%" }}
            flexDirection={{ xs: "column", sm: "row" }}
            marginLeft={{ xs: "0%", sm: "5%" }}
            marginBottom={2}
          >
            <Box
              display="flex"
              flexWrap={"wrap"}
              flexDirection={"column"}
              marginTop={{ xs: "10%", sm: "0%" }}
              width={{ xs: "90%", sm: "20%" }}
            >
              <Typography
                sx={{ textTransform: "capitalize", fontWeight: 700 }}
                gutterBottom
                color={"#33E68C"}
                align={"left"}
                variant={"body2"}
                paddingBottom={{ xs: "5%", sm: "10%" }}
              >
                Company
              </Typography>
              <Link
                underline="none"
                component="a"
                href="/aboutus"
                color="#bbb"
                variant={"body2"}
                fontWeight={700}
                paddingBottom={{ xs: "5%", sm: "10%" }}
                lineHeight={2}
                sx={{
                  "&:hover": {
                    color: "#fff",
                  },
                }}
              >
                About Us
              </Link>
              <Link
                underline="none"
                component="a"
                href="/"
                color="#bbb"
                variant={"body2"}
                fontWeight={700}
                paddingBottom={{ xs: "5%", sm: "10%" }}
                lineHeight={2}
                sx={{
                  "&:hover": {
                    color: "#fff",
                  },
                }}
              >
                Our Team
              </Link>
              <Link
                underline="none"
                component="a"
                href="/"
                color="#bbb"
                variant={"body2"}
                fontWeight={700}
                paddingBottom={{ xs: "5%", sm: "10%" }}
                lineHeight={2}
                sx={{
                  "&:hover": {
                    color: "#fff",
                  },
                }}
              >
                Blog
              </Link>
              <Link
                underline="none"
                component="a"
                href="/contact-us"
                color="#bbb"
                variant={"body2"}
                fontWeight={700}
                paddingBottom={{ xs: "5%", sm: "10%" }}
                lineHeight={2}
                sx={{
                  "&:hover": {
                    color: "#fff",
                  },
                }}
              >
                Contact Us
              </Link>
            </Box>
            <Box
              display="flex"
              flexWrap={"wrap"}
              flexDirection={"column"}
              marginTop={{ xs: "10%", sm: "0%" }}
              width={{ xs: "90%", sm: "20%" }}
            >
              <Typography
                sx={{ textTransform: "capitalize", fontWeight: 700 }}
                gutterBottom
                color={"#33E68C"}
                variant={"body2"}
                align={"left"}
                paddingBottom={{ xs: "5%", sm: "10%" }}
              >
                Services
              </Typography>
              <Link
                underline="none"
                component="a"
                href="/our-services"
                color="#bbb"
                variant={"body2"}
                fontWeight={700}
                paddingBottom={{ xs: "5%", sm: "10%" }}
                lineHeight={2}
                sx={{
                  "&:hover": {
                    color: "#fff",
                  },
                }}
              >
                Web Design
              </Link>
              <Link
                underline="none"
                component="a"
                href="/our-services"
                color="#bbb"
                variant={"body2"}
                fontWeight={700}
                paddingBottom={{ xs: "5%", sm: "10%" }}
                lineHeight={2}
                sx={{
                  "&:hover": {
                    color: "#fff",
                  },
                }}
              >
                Document Design
              </Link>
              <Link
                underline="none"
                component="a"
                href="/our-services"
                color="#bbb"
                variant={"body2"}
                fontWeight={700}
                paddingBottom={{ xs: "5%", sm: "10%" }}
                lineHeight={2}
                sx={{
                  "&:hover": {
                    color: "#fff",
                  },
                }}
              >
                Branding
              </Link>
              <Link
                underline="none"
                component="a"
                href="/our-services"
                color="#bbb"
                variant={"body2"}
                fontWeight={700}
                paddingBottom={{ xs: "5%", sm: "10%" }}
                lineHeight={2}
                sx={{
                  "&:hover": {
                    color: "#fff",
                  },
                }}
              >
                Data Analysis
              </Link>
            </Box>
            <Box
              display="flex"
              flexWrap={"wrap"}
              flexDirection={"column"}
              marginTop={{ xs: "10%", sm: "0%" }}
              width={{ xs: "90%", sm: "25%" }}
              alignItems={"flex-start"}
            >
              <Typography
                sx={{ textTransform: "capitalize", fontWeight: 700 }}
                gutterBottom
                color={"#33E68C"}
                align={"left"}
                variant={"body2"}
                paddingBottom={{ xs: "5%", sm: "10%" }}
              >
                Contact Us
              </Typography>
              <Box
                display={"flex"}
                alignItems={"flex-start"}
                marginLeft={{ xs: "0%", sm: "0%" }}
              >
                <PhoneIcon
                  sx={{
                    color: "#33E68C",
                    width: 18,
                    height: 18,
                  }}
                />{" "}
                <Typography
                  variant="body2"
                  color={"#bbb"}
                  sx={{
                    "&:hover": {
                      color: "#fff",
                    },
                  }}
                  textAlign={"left"}
                >
                  +234 703 533 5257
                </Typography>
              </Box>
              <Typography
                variant="body2"
                color={"#bbb"}
                sx={{
                  "&:hover": {
                    color: "#fff",
                  },
                }}
                textAlign={"left"}
                paddingBottom={{ xs: "5%", sm: "10%" }}
                marginLeft={{ xs: "6%", sm: "8%" }}
              >
                +44 7760 959733
              </Typography>
              <Box
                display={"flex"}
                alignItems={"flex-start"}
                paddingBottom={{ xs: "5%", sm: "10%" }}
                marginLeft={{ xs: "0%", sm: "0%" }}
              >
                <EmailIcon
                  sx={{
                    color: "#33E68C",
                    width: 18,
                    height: 18,
                  }}
                />{" "}
                <Typography
                  variant="body2"
                  color={"#bbb"}
                  sx={{
                    "&:hover": {
                      color: "#fff",
                    },
                  }}
                  textAlign={"left"}
                >
                  info@ondesign.io
                </Typography>
              </Box>
              <Box
                display={"flex"}
                alignItems={"flex-start"}
                justifyContent={"space-between"}
                paddingBottom={{ xs: "5%", sm: "10%" }}
                marginLeft={{ xs: "0%", sm: "0%" }}
              >
                <HouseIcon
                  sx={{
                    color: "#33E68C",
                    width: 18,
                    height: 18,
                  }}
                />{" "}
                <Typography
                  variant="body2"
                  color={"#bbb"}
                  sx={{
                    "&:hover": {
                      color: "#fff",
                    },
                  }}
                  textAlign={"left"}
                >
                  1, Ogunseitan Close, Williams Elliot Estate, Ifako Ijaiye,
                  Agege, Lagos
                </Typography>
              </Box>
            </Box>
            <Box
              display="flex"
              flexWrap={"wrap"}
              justifyContent={"space-between"}
              alignItems={"center"}
              flexDirection={{ xs: "row", sm: "column" }}
              width={{ xs: "100%", sm: "15%" }}
            >
              <Typography
                sx={{ textTransform: "capitalize", fontWeight: 700 }}
                gutterBottom
                color={"#33E68C"}
                align={"left"}
                variant={"body2"}
                display={{ xs: "none", sm: "block" }}
              >
                Follow Us
              </Typography>
              <Box
                display={"flex"}
                component="a"
                underline="none"
                target={"_blank"}
                href="https://twitter.com/OndesignTech"
                title="Twitter"
              >
                <Avatar
                  sx={{
                    bgcolor: "#bbb",
                    width: 36,
                    height: 36,
                    "&:hover": {
                      bgcolor: blue[300],
                    },
                  }}
                >
                  <TwitterIcon />
                </Avatar>
              </Box>
              <Box
                display={"flex"}
                component="a"
                underline="none"
                target={"_blank"}
                href="https://www.facebook.com/profile.php?id=100090206351887"
                title="Facebook"
              >
                <Avatar
                  sx={{
                    bgcolor: "#bbb",
                    width: 36,
                    height: 36,
                    "&:hover": {
                      bgcolor: blue[900],
                    },
                  }}
                >
                  <FacebookIcon />
                </Avatar>
              </Box>
              <Box
                display={"flex"}
                component="a"
                underline="none"
                target={"_blank"}
                href="https://www.instagram.com/ondesign.tech/"
                title="Instagram"
              >
                <Avatar
                  sx={{
                    bgcolor: "#bbb",
                    width: 36,
                    height: 36,
                    "&:hover": {
                      bgcolor: red[900],
                    },
                  }}
                >
                  <InstagramIcon />
                </Avatar>
              </Box>
              <Box
                display={"flex"}
                component="a"
                underline="none"
                target={"_blank"}
                href="https://www.linkedin.com/company/ondesigntechnologies/"
                title="LinkedIn"
              >
                <Avatar
                  sx={{
                    bgcolor: "#bbb",
                    width: 36,
                    height: 36,
                    "&:hover": {
                      bgcolor: blue[700],
                    },
                  }}
                >
                  <LinkedInIcon />
                </Avatar>
              </Box>
            </Box>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Divider color={"#fff"} />
        <Box
          display="flex"
          justifyContent={"space-between"}
          alignItems={"center"}
          flexWrap={"wrap"}
          width={"100%"}
          marginTop={"3%"}
        >
          <Box width={{ xs: "100%", sm: "100%" }}>
            <Typography align={"left"} variant={"subtitle2"} color="#bbb">
              &copy;{new Date().getFullYear()} OnDesign Technologies Ltd. All
              rights reserved
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Footer;
